import { useState } from "react";
import AccessForm from "./AccessForm";
import AccessTable from "./AccessTable";

export default function AccessMasterPage() {
  const [tab, setTab] = useState("FORM");
  const [editData, setEditData] = useState(null);

  return (
    <div>
      {/* Tabs */}
      <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
        <button onClick={() => setTab("FORM")}>Form</button>
        <button onClick={() => setTab("TABLE")}>View Data</button>
      </div>

      {tab === "FORM" && (
        <AccessForm editData={editData} clearEdit={() => setEditData(null)} />
      )}

      {tab === "TABLE" && (
        <AccessTable onEdit={(row) => {
          setEditData(row);
          setTab("FORM");
        }} />
      )}
    </div>
  );
}